import React from "react";
import { resolveDate } from "../../../lib/utils/resolveDate";
import { useTranslation } from "next-i18next";
import cn from "classnames";
import s from "./Datablock.InvestorGrid.module.scss";
import { usePressReleasesFeed } from "../../../hooks/mfn/usePressReleasesFeed";
import type { NewsItem } from "../../../hooks/mfn/usePressReleasesFeed";
import tokens from "../tokens.json";
import b from "../../../ui/Button/Button.module.scss";

type Props = {
  locale: string;
  browseAllHref?: string;
};

const PressReleases: React.FC<Props> = ({ browseAllHref, locale }) => {
  const { t } = useTranslation();
  const { newsItems, isLoading, error } = usePressReleasesFeed(
    tokens.pressReleases,
    locale
  );

  const generateItemUrl = (item: NewsItem) => {
    const baseUrl =
      locale === "sv"
        ? "/sv/media/pressmeddelanden"
        : "/newsroom/press-releases";
    const slug = item.content.slug;
    return `${baseUrl}?s=${slug}`;
  };

  if (error) {
    return (
      <div className={cn(s.item, s.pressReleases)}>
        <div className={s.error}>Unable to load press releases</div>
      </div>
    );
  }

  if (isLoading || !newsItems.length) {
    return (
      <div className={cn(s.item, s.pressReleases)}>
        <div className={s.loading}>{t("loading...")}</div>
      </div>
    );
  }

  return (
    <div className={cn(s.item, s.pressReleases)}>
      <div className={s.listHeading}>
        <h3>{t("latest-press-releases")}</h3>
        {browseAllHref && (
          <a
            className={cn(b.button, b.tag)}
            href={browseAllHref}
            title={t("latest-press-releases")}
          >
            {t("browse-all")}
          </a>
        )}
      </div>
      <ul className={s.list}>
        {newsItems.map((item) => (
          <li key={item.news_id} className={s.listItem}>
            <time dateTime={resolveDate(item.content.publish_date)}>
              {resolveDate(item.content.publish_date, locale)}
            </time>
            <a href={generateItemUrl(item)} className={s.title}>
              {item.content.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PressReleases;
